import { render } from "./index.vue?vue&type=template&id=c8613c8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.less?vue&type=style&index=0&id=c8613c8c&scoped=true&lang=less"

import exportComponent from "/Users/zhanghao/Documents/beijing/maidong/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8613c8c"]])

export default __exports__